<template>
  <div class="sf-el hidden-input">
    <div class="sf-hidden">
      <label v-if="context === 'editor'" class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <input type="hidden" v-model="value" />
      <input v-if="context === 'editor'" type="text" disabled v-model="value" />
    </div>
  </div>
</template>

<script>
  import { watch, ref } from 'vue';
  export default {
    name: 'HiddenElement',
    props: {
      label: String,
      name: String,
      modelValue: String,
      context: String,
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const value = ref(props.modelValue);
      watch(value, (newValue) => {
        emit('update:modelValue', newValue);
      });
      return {
        value,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-hidden {
    display: none;
    visibility: hidden;
    .sf-el__label {
      opacity: 0.5;
    }
  }
</style>
